var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FormField"},[_c('header',{staticClass:"FormField__Header"},[(_vm.$slots.icon)?_vm._t("icon"):_vm._e(),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.label))])],2),_vm._v(" "),_c('section',{class:{
      'FormField__Content': true,
      'underline': _vm.underline,
    }},[(_vm.$slots.default)?_vm._t("default"):[(_vm.$slots.prefix)?_vm._t("prefix"):_vm._e(),_vm._v(" "),_c('div',{staticClass:"FormField__Content__InputWrapper"},[_c('input',{attrs:{"type":_vm.type === 'number' ? 'text' : _vm.type,"readonly":_vm.readOnly,"placeholder":_vm.placeholder,"maxLength":_vm.maxLength},domProps:{"value":_vm.value},on:{"input":function (ref) {
            var target = ref.target;

            var v = (
              _vm.type === 'number'
              ? target.value.replace(/\D/g, '')
              : target.value
            )
            _vm.$emit('input', v)
            target.value = v
          }}})]),_vm._v(" "),(_vm.$slots.suffix)?_vm._t("suffix"):_vm._e()]],2),_vm._v(" "),_c('footer',{staticClass:"FormField__Footer"},[(_vm.tips)?_c('div',{staticClass:"FormField__Footer__Tips"},[_vm._v(_vm._s(_vm.tips))]):_vm._e(),_vm._v(" "),(_vm.$slots.footer)?_vm._t("default"):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-228f0277","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/build800/views/My/Wallet/AddWallet/components/FormField.vue
// module id = null
// module chunks = 